/**
 * Recently Viewed Products – Tracks viewed products and renders them via Section Rendering API.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mts-recently-viewed';
  var SECTION_ID = 'recently-viewed-card';

  function trackCurrentProduct() {
    if (typeof window.MtsStorage === 'undefined') return;
    var meta = document.querySelector('meta[property="og:type"][content="product"]');
    if (!meta) return;

    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    window.MtsStorage.addItem(STORAGE_KEY, { handle: handle, viewedAt: Date.now() });
  }

  function renderRecentlyViewed(container) {
    if (!container || typeof window.MtsStorage === 'undefined') return;

    var items = window.MtsStorage.getItems(STORAGE_KEY);
    var maxItems = parseInt(container.dataset.maxItems, 10) || 6;
    var currentHandle = container.dataset.currentHandle || '';

    // Exclude current product
    items = items.filter(function (i) { return i.handle !== currentHandle; });
    items = items.slice(0, maxItems);

    if (items.length === 0) {
      container.closest('.recently-viewed-section').style.display = 'none';
      return;
    }

    var grid = container.querySelector('.recently-viewed__grid');
    if (!grid) return;

    var fetches = items.map(function (item) {
      return fetch('/products/' + item.handle + '?section_id=' + SECTION_ID)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    });

    Promise.all(fetches).then(function (htmlArray) {
      var fragment = document.createDocumentFragment();
      htmlArray.forEach(function (html) {
        if (!html) return;
        var li = document.createElement('li');
        li.className = 'grid__item scroll-trigger animate--slide-in';
        li.innerHTML = html;
        fragment.appendChild(li);
      });

      if (fragment.children.length === 0) {
        container.closest('.recently-viewed-section').style.display = 'none';
        return;
      }

      grid.innerHTML = '';
      grid.appendChild(fragment);
      container.closest('.recently-viewed-section').style.display = '';
    });
  }

  // Track on product pages
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackCurrentProduct);
  } else {
    trackCurrentProduct();
  }

  // Render when section scrolls into view (lazy)
  var section = document.querySelector('.recently-viewed-section');
  if (section) {
    var container = section.querySelector('[data-recently-viewed]');
    if (container && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            renderRecentlyViewed(container);
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(section);
    } else if (container) {
      renderRecentlyViewed(container);
    }
  }
})();
